export class PackageViewModel {
	readonly id: string;
	readonly label: string;

	constructor (id: string, label: string) {
		this.id = id;
		this.label = label;
	}
}
